import { Pipe, PipeTransform } from '@angular/core';
import { ContactsSearchOrder } from '@app-types/enums/contacts';

@Pipe({
  name: 'formatContactsSearchOrders',
  standalone: true,
})
export class FormatContactsSearchOrders implements PipeTransform {
  transform(order: string): ContactsSearchOrder {
    switch (order) {
      case 'alias':
        return ContactsSearchOrder.OrderByAlias;
      case 'lastName':
        return ContactsSearchOrder.OrderByLastName;
      case 'name':
        return ContactsSearchOrder.OrderByFirstName;
      case 'companyName':
        return ContactsSearchOrder.OrderByCompanyName;
      case 'mailAccount':
        return ContactsSearchOrder.OrderByEmail;
      default:
        return ContactsSearchOrder.OrderByContactId;
    }
  }
}
